import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector   : 'particle-speech-with-action',
  templateUrl: './speech-with-action.component.html',
  styleUrls  : ['./speech-with-action.component.scss']
})
export class SpeechWithActionComponent implements OnInit {
  @Input() speech: any;

  constructor () {
    const obj = {
      message    : `You\'ll be notified here and via <a id = 'supportticketid' (click)="performAction('openTask', '500')">wow</a> support ticket when you receive a response.`,
      isMine     : false,
      createdDate: new Date(),
      type       : 'SpeechWithAction',
      metadata : {
        buttons: [{
          btn1: {

          }
        }]
      }
    }
  }

  ngOnInit () {
    console.log(this.speech);
  }

  performAction(id){
    console.log(id);
  }
}
